import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Account } from '../entities/account';
import { LoginData } from '../entities/login-data';
import { RegisterData } from '../entities/register-data';

const actionFeatureKey = 'Auth';

export const checkAuthentication = createAction(`[${actionFeatureKey}] Check Authentication`);

export const register = createAction(`[${actionFeatureKey}/API] Register`, props<RegisterData>());
export const authenticate = createAction(`[${actionFeatureKey}/API] Authenticate`, props<LoginData>());
export const authenticationSuccess = createAction(`[${actionFeatureKey}/API]`);
export const authenticationFailure = createAction(
    `[${actionFeatureKey}/API] Authentication failure`,
    props<{ error: HttpErrorResponse | null }>()
);

export const setAccount = createAction(`[${actionFeatureKey}] Set account`, props<{ account: Account }>());
export const setToken = createAction(`[${actionFeatureKey}] Set token`, props<{ token: string }>());
export const setIsAuthenticated = createAction(
    `[${actionFeatureKey}] Set is authenticated`,
    props<{ isAuthenticated: boolean }>()
);
export const accountInitiallyRequested = createAction(`[${actionFeatureKey}] Account requested`);
export const clearError = createAction(`[${actionFeatureKey}] Clear error`);
export const navigateToLogin = createAction(`[${actionFeatureKey}] Navigate to login`, props<{ url: string }>());
export const logout = createAction(`[${actionFeatureKey}] Logout`);
